import React, { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useMediaQuery } from 'react-responsive';
import playerStore from '../../stores/player';
import { Capacitor } from '@capacitor/core';
import muvikaAttrs from './../../attrs';
import { checkIfMobile } from '../../services/screen';
import performanceStore from '../../stores/performance';
import navigationStore from '../../stores/navigation';
import { Views } from './../../enums/enums';
import musicStore from '../../stores/music';

const mobilePlayerHeightMinus = 135;
const bottomBarHeightMinus = 65;
const desktopHeightMinus = 15;
const songbookHeightMinus = 1;
const minHeightMobile = 70;
const minHeightDesktop = 70;
const minHeightCatalog = 370;

function ContentContainer(props) {

  const isSearchFiltersOn = navigationStore((state) => state.isSearchFiltersOn);
  const safeArea = navigationStore((state) => state.safeArea);
  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const isOn = performanceStore((state) => state.isOn);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const currentPerformanceId = performanceStore((state) => state.currentPerformanceId);
  const currentTrack = playerStore((state) => state.currentTrack);
  const playQueue = performanceStore((state) => state.playQueue);
  const currentView = navigationStore((state) => state.currentView);
  const paddingBottoms = navigationStore((state) => state.paddingBottoms);

  const containerRef = useRef();

  const scrollPositionRef = useRef(0);
  const humanActive = useRef(false);

  useEffect(() => {
    if (props.id === "muvika-player-content-container") {
      if (playerStore.getState().isPlaying.isPlaying) {
        if (containerRef) {
          if (containerRef.current) {
            console.log("scroller perf");
            scrollPositionRef.current = 0;
            containerRef.current.scrollTop = 0;
          }
        }
      }
    }
  }, [currentPerformance]);

  const calcMobileBottom = () => {
    let bottomBarEl = document.getElementById("muvika-bottom-bar-paper");
    let mobileCardEl = document.getElementById("muvika-mobile-player-card");
    if (currentView != Views.Blank && isShowingMobilePlayer && !props.isSongbook) {
      if (bottomBarEl && mobileCardEl) {
        console.log("calcMobileBottom", (bottomBarEl.clientHeight + mobileCardEl.clientHeight));
        return bottomBarEl.clientHeight + mobileCardEl.clientHeight - (safeArea ? safeArea.bottom : 0);
      }
    } else {
      if (props.isSongbook) {
        return 55;
      } else {
        if (bottomBarEl) {
          return bottomBarEl.clientHeight - (safeArea ? safeArea.bottom : 0);
        }
      }
    }
  };

  const calcHeight = () => {
    if (containerRef.current) {
      let containerPos = containerRef.current.getBoundingClientRect().top;
      if (checkIfMobile()) {
        console.log("navview", currentView, isShowingMobilePlayer);
        return window.innerHeight - calcMobileBottom() - containerPos;
      } else if (props.isSongbook) {
        return window.innerHeight - songbookHeightMinus - containerPos;
      } else {
        return window.innerHeight - desktopHeightMinus - containerPos;
      }
    }
  };

  const pxToRem = (px) => {
    const rootFontSize = parseFloat(document.documentElement.style.fontSize);
    return px / rootFontSize;
  };

  const setContainerHeight = (height) => {
    if (containerRef) {
      let id = containerRef.current.id;
      let paddingBottomsState = navigationStore.getState().paddingBottoms;
      if (paddingBottomsState[id]) {
        height += paddingBottomsState[id];
      }
      console.log("setContainerHeight", id, document.documentElement.style.fontSize, height, pxToRem(height));
      if (Capacitor.isNativePlatform()) {
        containerRef.current.style.height = (height - 5) + 'px';
      } else {
        containerRef.current.style.height = height + 'px';
      }
    }
  };

  const handleResize = () => {
    console.log("handleResize()");
    var height = calcHeight();
    if (safeArea) {
      height = height - safeArea.bottom;
    }
    if (checkIfMobile()) {
      if (props.isCatalog) {
        if (height > minHeightCatalog) {
          setContainerHeight(height);
        }
      } else {
        if (height > minHeightMobile) {
          setContainerHeight(height);
        }
      }
    } else {
      if (props.isCatalog) {
        if (height > minHeightCatalog) {
          setContainerHeight(height);
        }
      } else {
        if (height > minHeightDesktop) {
          setContainerHeight(height);
        }
      }
    }
    window.dispatchEvent(new Event('refitcontainer'));
  };

  useEffect(() => {
    console.log("container rerender");
    if (!isSearchFiltersOn) {
      handleResize();
    }
  });

  useEffect(() => {
    handleResize();
  }, [paddingBottoms]);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 100);
  }, [isSearchFiltersOn]);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 100);
  }, [currentView]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', () => {
      handleResize();
    });
  }, []);

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const isShowingMobilePlayer = currentView != Views.Player;

  return (
    <div ref={containerRef}
      id={props.id}
      className="muvika-content-container"
      style={{ minHeight: checkIfMobile() ? minHeightMobile + "px" : minHeightDesktop + "px" }}
      onScroll={() => {
        console.log("scrolling", containerRef.current.scrollTop);
        if (props.onScroll) {
          props.onScroll(containerRef.current.scrollTop, containerRef.current.scrollHeight - containerRef.current.clientHeight);
        }
      }}>
      <InfiniteScroll pageStart={0}
        initialLoad={false}
        loadMore={() => {
          if (props.onScrollDown) {
            props.onScrollDown();
          }
        }}
        hasMore={!props.isFinished}
        useWindow={false}
      >
        {props.children}
      </InfiniteScroll>
    </div>
  );
}

export default ContentContainer;